export default "__VITE_ASSET__6744bd1c__"